/**
 * Persistence for the FPS briefing "Don't show this briefing again" checkbox.
 *
 * Lives in lib/ rather than in the page module because App.tsx reads the
 * flag when routing stake → briefing, and FPSBriefingScreen is lazy-loaded —
 * importing it from the page would fold the briefing chunk into the main
 * bundle.
 */

const STORAGE_KEY = "hupper.fpsBriefing.skip";

export function loadSkipFpsBriefing(): boolean {
  if (typeof window === "undefined") return false;
  try {
    return window.localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

export function saveSkipFpsBriefing(skip: boolean): void {
  if (typeof window === "undefined") return;
  try {
    if (skip) window.localStorage.setItem(STORAGE_KEY, "1");
    else window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* private mode / quota — non-fatal */
  }
}
